<template>
    <div class="animated revealUp">
        <div class="white-wrapper">
            <div class="section-title mb-4">
                {{ $t("Distributor Collection Report") }}
            </div>
            <div class="row align-items-center">
                <div class="col-lg-2 mt-2">
                    <div class="dropdown-curve-container">
                        <label :class="selectedData.cinema_id
                            ? 'shift-up'
                            : 'font-weight-bold'
                            ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                        <multiselect v-model="selectedData.cinema_id" :options="cinemasList" open-direction="bottom"
                            :show-labels="false" label="cine_name" track-by="cine_id" @input="fetchMoviesList" />
                    </div>
                </div>
                <div class="col-lg-2 mt-2">
                    <div class="input-material">
                        <div class="add-datepicker">
                            <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                                v-validate="'required'" @input="fetchMoviesList"></Datepicker>
                            <label :class="fromDate ? 'active' : ''">
                                {{ $t("show") }}
                                {{ $t("fromdate") }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 mt-2">
                    <div class="input-material">
                        <div class="add-datepicker">
                            <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="toDate"
                                v-validate="'required'" @input="fetchMoviesList"></Datepicker>
                            <label :class="toDate ? 'active' : ''">
                                {{ $t("show") }}
                                {{ $t("todate") }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 mt-2">
                    <div class="dropdown-curve-container">
                        <label :class="selectedData.d_id
                            ? 'shift-up'
                            : 'font-weight-bold'
                            ">Select Distributor</label>
                        <multiselect v-model="selectedData.d_id" :options="distributorsList" open-direction="bottom"
                            :show-labels="false" label="d_company_name" track-by="d_id" @input="fetchMoviesList" />
                    </div>
                </div>
                <div class="col-lg-3 mt-2">
                    <div class="dropdown-curve-container">
                        <label :class="selectedData.movie_id
                            ? 'shift-up'
                            : 'font-weight-bold'
                            ">Select Movie</label>
                        <multiselect v-model="selectedData.movie_id" :options="moviesList" open-direction="bottom"
                            :show-labels="false" label="movie_title" track-by="movie_id"
                            @input="handleMovieSelection" />
                    </div>
                </div>
                <div class="col-lg-3 mt-2">
                    <div class="dropdown-curve-container">
                        <label :class="selectedData.md_id
                            ? 'shift-up'
                            : 'font-weight-bold'
                            ">Select Feature Versions</label>
                        <multiselect v-model="selectedData.md_id" :options="movieDetailsList" open-direction="bottom"
                            :show-labels="false" label="movie_details_name" track-by="md_id" :multiple="true"
                            @input="handleMovieSelection" />
                    </div>
                </div>
                <div class="col-lg-3 mt-3">
                    <button class="btn btn-blue" @click="fetchDistributorReport">Fetch Report</button>
                </div>
                <div class="col-lg-3 mt-3">
                    <div class="mr-2">Download as: <a download target="_blank" title="Download as PDF"
                            @click="fetchDistributorReport('N', 'Y')">
                            <img height="25" src="@/assets/img/icons/pdf-icon.svg" width="25" />
                        </a>

                        <a download target="_blank" title="Download as Excel" @click="fetchDistributorReport('Y', 'N')">
                            <img height="25" src="@/assets/img/icons/excel.svg" width="25" />
                        </a>
                    </div>

                </div>
            </div>
            <div class="swc-report table-scroll pr-2 mt-4">
                <table border="1" class="swc-report-table">
                    <thead>
                        <tr class="font-weight-bold table-header-bg">
                            <th>Show Date</th>
                            <th>Show Time</th>
                            <th>Movie Name</th>
                            <th>Audi Name</th>
                            <th>No. of Shows</th>
                            <th>Week</th>
                            <th>Ticket Rate</th>
                            <th>Footfall</th>
                            <th>Discount</th>
                            <th>Gross</th>
                            <th>Net</th>
                            <th>Net w/o 3D</th>
                            <th>Week %</th>
                            <th>Movie Share</th>
                            <th>Distributor</th>
                        </tr>
                    </thead>
                    <tbody v-if="transactionsData.length">
                        <template v-for="movie in transactionsData">
                            <template v-for="transaction in movie.movieTransactions">
                                <template v-for="(seatType, seatIndex) in transaction.seatTypes">
                                    <tr v-if="seatIndex == 0"
                                        :key="`${seatType.seat_type_name}_seats_${transaction.ss_id}_${seatIndex}`">
                                        <td v-if="seatIndex == 0" :rowspan="transaction.seatTypes.length + 1"
                                            class="text-left">{{
                                                transaction.seatTypes[0].show_date }}
                                        </td>
                                        <td v-if="seatIndex == 0" :rowspan="transaction.seatTypes.length + 1"
                                            class="text-left">{{
                                                transaction.seatTypes[0].show_time }}
                                        </td>
                                        <td class="table-total-bg text-left">{{ seatType.movie_name }}</td>
                                        <td class="table-total-bg text-left"></td>
                                        <td class="table-total-bg text-right">{{ seatType.no_of_shows }}</td>
                                        <td class="table-total-bg text-right">Week-{{ seatType.week_count }}</td>
                                        <td class="table-total-bg text-left"></td>
                                        <td class="table-total-bg text-right">{{transaction.seatTypes.reduce((acc, {
                                            footfall }) => {
                                            return acc + footfall
                                        }, 0)}}</td>
                                        <td class="table-total-bg text-right">{{transaction.seatTypes.reduce((acc, {
                                            offer_price }) => {
                                            return acc + offer_price
                                        }, 0)}}</td>
                                        <td class="table-total-bg text-right">{{transaction.seatTypes.reduce((acc, {
                                            gross }) => {
                                            return acc + gross
                                        }, 0)}}</td>
                                        <td class="table-total-bg text-right">{{transaction.seatTypes.reduce((acc, { net
                                        }) => {
                                            return acc + net
                                        }, 0)}}</td>
                                        <td class="table-total-bg text-right">{{transaction.seatTypes.reduce((acc, {
                                            net, prod_rate
                                        }) => {
                                            return acc + (net - prod_rate)
                                        }, 0)}}</td>
                                        <td class="table-total-bg text-left"></td>
                                        <td class="table-total-bg text-right">{{ currFormat(seatType.week_share) }}</td>
                                        <td v-if="seatIndex == 0" :rowspan="transaction.seatTypes.length + 1"
                                            class="text-right">{{
                                                transaction.seatTypes[0].distributor_name }}
                                        </td>
                                    </tr>
                                    <tr :key="`${seatType.seat_type_name}_seats_${transaction.ss_id}_${seatIndex}`">
                                        <td class="text-left">{{ seatType.seat_type_name }}</td>
                                        <td class="text-left">{{ seatType.screen_name }}</td>
                                        <td class="text-right"></td>
                                        <td></td>
                                        <td class="text-right">{{ seatType.ticket_rate }}</td>
                                        <td class="text-right">{{ seatType.foot_fall }}</td>
                                        <td class="text-right">{{ currFormat(seatType.offer_price) }}
                                        </td>
                                        <td class="text-right">{{ currFormat(seatType.gross) }}</td>
                                        <td class="text-right">{{ currFormat(seatType.net) }}</td>
                                        <td class="text-right">{{
                                            currFormat(seatType.net - seatType.prod_rate) }}
                                        </td>
                                        <td>{{ currFormat(seatType.week_percentage) }}</td>
                                        <td class="text-right">{{ currFormat(seatType.week_share) }}</td>
                                    </tr>
                                </template>
                            </template>
                            <tr :key="`${movie.md_id}_${movie.movie_name}_sub_totals`" class="table-total-bg"
                                v-if="movieBasedTotals[movie.md_id]">
                                <td class="text-left">Total</td>
                                <td class="text-left"></td>
                                <td class="text-left"></td>
                                <td class="text-left"></td>
                                <td class="text-right">{{ movieBasedTotals[movie.md_id].shows.length }}</td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{ movieBasedTotals[movie.md_id].footfall }}</td>
                                <td class="text-right">{{ currFormat(movieBasedTotals[movie.md_id].offer_price) }}
                                </td>
                                <td class="text-right">{{ currFormat(movieBasedTotals[movie.md_id].gross) }}</td>
                                <td class="text-right">{{ currFormat(movieBasedTotals[movie.md_id].net) }}</td>
                                <td class="text-right">
                                    {{ currFormat(movieBasedTotals[movie.md_id].net -
                                        movieBasedTotals[movie.md_id].prod_rate) }}
                                </td>
                                <td></td>
                                <td class="text-right">{{ currFormat(movieBasedTotals[movie.md_id].week_share) }}</td>
                                <td></td>
                            </tr>
                            <tr :key="movie.md_id">
                                <td colspan="15" class="py-3"></td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-if="transactionsData.length == 0">
                        <tr>
                            <td colspan="12">No Records</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template v-if="selectedData['movie_id'] && selectedData['movie_id']['movie_id']">
                <div class="swc-report table-scroll pr-2 mt-4">
                    <table border="1" class="swc-report-table">
                        <thead>
                            <tr class="font-weight-bold">
                                <td colspan="2">Summary</td>
                            </tr>
                            <tr class="font-weight-bold table-header-bg">
                                <td>Shows</td>
                                <td>No of Shows</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-left">Todays Shows</td>
                                <td class="text-right">{{ scheduleSummary.today }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">Previous Shows</td>
                                <td class="text-right">{{ scheduleSummary.previous }}</td>
                            </tr>
                            <tr class="table-total-bg">
                                <td class="text-left">Total Shows</td>
                                <td class="text-right">{{ (scheduleSummary.today || 0) + (scheduleSummary.previous || 0)
                                    }}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div class="swc-report table-scroll pr-2 mt-4">
                    <table border="1" class="swc-report-table">
                        <thead>
                            <tr class="font-weight-bold">
                                <td colspan="6" class="text-center">Last 7 Days</td>
                            </tr>
                            <tr class="font-weight-bold table-header-bg">
                                <td>Day</td>
                                <td>Shows</td>
                                <td>Admits</td>
                                <td>Net</td>
                                <td>3D Net</td>
                                <td>Gross Net</td>
                            </tr>
                        </thead>
                        <tbody v-if="Object.keys(lastWeekSummary).length">
                            <tr v-for="(weekData, weekIndex) in Object.keys(lastWeekSummary)"
                                :key="weekIndex + weekData">
                                <td class="text-left">{{ lastWeekSummary[weekData]["date"] }}</td>
                                <td class="text-right">{{ lastWeekSummary[weekData]["shows"] }}</td>
                                <td class="text-right">{{ lastWeekSummary[weekData]["admits"] }}</td>
                                <td class="text-right">{{ currFormat(lastWeekSummary[weekData]["net"]) }}</td>
                                <td class="text-right">{{ currFormat(lastWeekSummary[weekData]["prod_rate"]) }}</td>
                                <td class="text-right">{{ currFormat(lastWeekSummary[weekData]["gross"]) }}</td>
                            </tr>
                            <tr class="table-total-bg">
                                <td class="text-left">Total</td>
                                <td class="text-right">{{ lastWeekSummaryTotal.shows }}</td>
                                <td class="text-right">{{ lastWeekSummaryTotal.admits }}</td>
                                <td class="text-right">{{ currFormat(lastWeekSummaryTotal.net) }}</td>
                                <td class="text-right">{{ currFormat(lastWeekSummaryTotal.prod_rate) }}</td>
                                <td class="text-right">{{ currFormat(lastWeekSummaryTotal.gross) }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6">
                                    No Records
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="swc-report table-scroll pr-2 mt-4"
                    v-if="selectedData.d_id && selectedData.d_id.d_id && selectedData.md_id && selectedData.md_id.length == 1">
                    <table border="1" class="swc-report-table">
                        <thead>
                            <tr class="font-weight-bold">
                                <td colspan="8" class="text-center">Full Cycle</td>
                            </tr>
                            <tr class="font-weight-bold table-header-bg">
                                <td>Week</td>
                                <td>Shows</td>
                                <td>Admits</td>
                                <td>Net</td>
                                <td>Share %</td>
                                <td>Net Share</td>
                                <td>Gross</td>
                                <td>3D Gross</td>
                            </tr>
                        </thead>
                        <tbody v-if="movieWeekSummary && movieWeekSummary.length">
                            <tr v-for="(weekSummaryObj, weekSummaryIndex) in movieWeekSummary"
                                :key="weekSummaryIndex + 'movieWeek'">
                                <td class="text-left">Week-{{ weekSummaryObj.week }}</td>
                                <td class="text-right">{{ weekSummaryObj.shows.length }}</td>
                                <td class="text-right">{{ weekSummaryObj.admits }}</td>
                                <td class="text-right">{{ currFormat(weekSummaryObj.net) }}</td>
                                <td class="text-right">{{ currFormat(weekSummaryObj.share_percentage) }}%</td>
                                <td class="text-right">{{ currFormat(weekSummaryObj.net_share) }}</td>
                                <td class="text-right">{{ currFormat(weekSummaryObj.gross) }}</td>
                                <td class="text-right">{{ currFormat(weekSummaryObj.prod_rate) }}</td>
                            </tr>
                            <tr class="table-total-bg">
                                <td class="text-left">Totals</td>
                                <td class="text-right">{{ movieWeekSummaryTotal.shows }}</td>
                                <td class="text-right">{{ movieWeekSummaryTotal.admits }}</td>
                                <td class="text-right">{{ currFormat(movieWeekSummaryTotal.net) }}</td>
                                <td></td>
                                <td class="text-right">{{ currFormat(movieWeekSummaryTotal.net_share) }}</td>
                                <td class="text-right">{{ currFormat(movieWeekSummaryTotal.gross) }}</td>
                                <td class="text-right">{{ currFormat(movieWeekSummaryTotal.prod_rate) }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8">No Records</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ReportsServiceV2 from "@/services/ReportsService-v2";
import moment from "moment"

export default {
    data() {
        return {
            cinemasList: [],
            moviesList: [],
            movieDetailsList: [],
            distributorsList: [],
            fromDate: new Date(),
            toDate: new Date(),
            selectedData: {
                cinema_id: null,
                movie_id: null,
                md_id: null,
                d_id: null
            },
            movieBasedTotals: {},
            transactionsData: [],
            scheduleSummary: {
                today: 0,
                previous: 0,
            },
            lastWeekSummary: {},
            lastWeekSummaryTotal: {
                shows: 0, admits: 0, net: 0, prod_rate: 0, gross: 0
            },
            movieWeekSummary: {},
            movieWeekSummaryTotal: {
                shows: 0,
                admits: 0,
                net: 0,
                prod_rate: 0,
                share_percentage: 0,
                net_share: 0,
                gross: 0,
            }
        }
    },
    beforeMount() {
        this.fetchCinemasList()
        this.fetchDistributorsList()
    },
    methods: {
        fetchCinemasList: async function () {
            try {
                const response = await MasterService.GetActiveList({
                    tableName: "ms_cinemas",
                    cine_is_active: "Y",
                })

                const { data } = response || {}
                if (!data.status || !data.Records || !data.Records.length) {
                    return this.$toasted.show("Failed to fetch cinemas List")
                }

                this.cinemasList = [...data.Records]
            } catch (error) {
                console.log(error)
            }
        },
        fetchDistributorsList: async function () {
            try {
                const response = await MasterService.GetActiveList({
                    tableName: "ms_distributors",
                    d_is_active: "Y",
                })

                const { data } = response || {}
                if (!data.status || !data.Records || !data.Records.length) {
                    return this.$toasted.show("Failed to fetch Distributors List")
                }

                this.distributorsList = [...data.Records]
            } catch (error) {
                console.log(error)
            }
        },
        fetchMoviesList: async function () {
            try {
                const response = await ReportsServiceV2.getScheduledMoviesDropDown({
                    movie_id: this.selectedData["movie_id"] ? this.selectedData["movie_id"]["movie_id"] : null,
                    cinema_id: this.selectedData["cinema_id"] ? this.selectedData["cinema_id"]["cine_id"] : null,
                    d_id: this.selectedData["d_id"] ? this.selectedData["d_id"]["d_id"] : null,
                    fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                    toDate: moment(this.toDate).format("YYYY-MM-DD"),
                })

                const { data } = response || {}
                if (!data.status || !data.Records || !data.Records.length) {
                    return this.$toasted.show("No movies found")
                }

                if (!this.selectedData["md_id"]) {
                    this.moviesList = [...data.Records]
                } else {
                    this.movieDetailsList = [...data.Records]
                }
            } catch (error) {
                console.log(error)
            }
        },
        handleMovieSelection: async function () {
            try {
                const response = await ReportsServiceV2.getScheduledMoviesDropDown({
                    movie_id: this.selectedData["movie_id"] ? this.selectedData["movie_id"]["movie_id"] : null,
                    cinema_id: this.selectedData["cinema_id"] ? this.selectedData["cinema_id"]["cine_id"] : null,
                    fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                    toDate: moment(this.toDate).format("YYYY-MM-DD"),
                })

                const { data } = response || {}
                if (!data.status || !data.Records || !data.Records.length) {
                    return this.$toasted.show("Failed to fetch movies details list")
                }

                this.movieDetailsList = [...data.Records]
            } catch (error) {
                console.log(error)
            }
        },
        fetchDistributorReport: async function (isExcel = "N", isPdf = "N") {
            if (!this.selectedData["cinema_id"]) {
                return this.$toasted.show("Please select cinema")
            }
            if (!this.fromDate) {
                return this.$toasted.show("Please select from date")
            }
            if (!this.toDate) {
                return this.$toasted.show("Please select to date")
            }
            let loader = this.$loading.show();

            this.transactionsData = [];
            this.scheduleSummary = {
                today: 0,
                previous: 0,
            }
            this.lastWeekSummary = {},
                this.lastWeekSummaryTotal = {
                    shows: 0, admits: 0, net: 0, prod_rate: 0, gross: 0
                }
            this.movieWeekSummary = {}
            this.movieWeekSummaryTotal = {
                shows: 0,
                admits: 0,
                net: 0,
                prod_rate: 0,
                share_percentage: 0,
                net_share: 0,
                gross: 0,
            }
            try {
                const payload = {
                    cinema_id: this.selectedData["cinema_id"]["cine_id"],
                    cinema_name: this.selectedData["cinema_id"]["cine_name"],
                    cinema_address: this.selectedData["cinema_id"]["cine_address"],
                    movie_id: this.selectedData["movie_id"] ? this.selectedData["movie_id"]["movie_id"] : null,
                    md_id: this.selectedData["md_id"] && this.selectedData["md_id"].length ? this.selectedData["md_id"].map(mdObj => {
                        return mdObj.md_id
                    }) : null,
                    d_id: this.selectedData["d_id"] ? this.selectedData["d_id"]["d_id"] : null,
                    fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                    toDate: moment(this.toDate).format("YYYY-MM-DD"),
                    isExcel,
                    isPdf
                }

                const response = await ReportsServiceV2.getQFXDistributorCollectionReportV2(payload)

                const { data } = response || {}
                if (!data.status || !data.Records || !data.Records.length) {
                    return this.$toasted.show("Failed to fetch report")
                }

                this.transactionsData = [...data.movieSeatGroupedTransactions]

                this.movieBasedTotals = { ...data.movieWiseTransacitonTotals }

                if (data["scheduleSummaryValues"]) {
                    this.scheduleSummary = { ...data.scheduleSummaryValues }
                }

                if (data["lastWeekDataValues"]) {
                    this.lastWeekSummary = { ...data["lastWeekDataValues"] }
                    Object.keys(data["lastWeekDataValues"]).forEach(weekObj => {
                        this.lastWeekSummaryTotal["shows"] += +parseFloat(data["lastWeekDataValues"][weekObj]["shows"])
                        this.lastWeekSummaryTotal["admits"] += +parseFloat(data["lastWeekDataValues"][weekObj]["admits"])
                        this.lastWeekSummaryTotal["net"] += +parseFloat(data["lastWeekDataValues"][weekObj]["net"])
                        this.lastWeekSummaryTotal["prod_rate"] += +parseFloat(data["lastWeekDataValues"][weekObj]["prod_rate"])
                        this.lastWeekSummaryTotal["gross"] += +parseFloat(data["lastWeekDataValues"][weekObj]["gross"])
                    })
                }

                if (data["weekSummaryValues"]) {
                    this.movieWeekSummary = data["weekSummaryValues"]

                    data["weekSummaryValues"].forEach(weekSummaryObj => {
                        this.movieWeekSummaryTotal["shows"] += +parseFloat(weekSummaryObj.shows.length)
                        this.movieWeekSummaryTotal["admits"] += +parseFloat(weekSummaryObj.admits)
                        this.movieWeekSummaryTotal["net"] += +parseFloat(weekSummaryObj.net)
                        this.movieWeekSummaryTotal["prod_rate"] += +parseFloat(weekSummaryObj.prod_rate)
                        this.movieWeekSummaryTotal["net_share"] += +parseFloat(weekSummaryObj.net_share)
                        this.movieWeekSummaryTotal["gross"] += +parseFloat(weekSummaryObj.gross)
                    })
                }

                if (data["excelPath"]) {
                    window.open(data.excelPath, "_blank");
                }
                if (data["pdfPath"]) {
                    window.open(data.pdfPath, "_blank");
                }
            } catch (error) {
                console.log(error)
            } finally {
                loader.hide()
            }
        },
        totalSeatWiseData(transaction) {
            // Calculate total number of seatWiseData entries across all seatTypes for given ss_id
            return transaction.seatTypes.reduce((sum, seatType) => {
                return sum + seatType.seatWiseData.length;
            }, 0);
        }
    }
}
</script>
<style scoped>
.table-header-bg {
    background-color: rgb(209 216 226)
}

.table-total-bg {
    background-color: rgb(224 236 255);
    font-weight: 600
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorCollectionReportQfxV2.vue